<template lang="pug">
  v-img(
    v-if="imageExists"
    :contain="contain"
    :aspectRatio="ratio"
    :srcset="srcsetWebp"
    :lazy-src="lazySrc"
    :sizes="sizes"
    :src="src"
    @click="$emit('selectImage')"
  )

  v-img(
    v-else
    :contain="false"
    aspectRatio="1.5"
    src="img/default-profile.png"
    @click="$emit('selectImage')"
  )

</template>

<script>
import gql from 'graphql-tag'

export default {
  props: ['img', 'imgId', 'type', 'contain', 'aspectRatio'],

  apollo: {
    getUploadById: {
      query: gql`
        query ($id: ID!){
          getUploadById( id: $id ) {
            id
            path
            aspectRatio
            mediaType
            filename
          }
        }
      `,
      skip() {
        try{
          return !this.initialImgId && !this.img
        }catch(err) {
          return true
        }
      },
      variables () {
        return {
          id: this.initialImgId || this.img.id
        }
      }
    }
  },

  data () {
    return {
      errImg: false,
      initialImgId: this.imgId || null
    }
  },

  watch: {
    imgId(newVal) {
      this.initialImgId = newVal
    }
  },

  computed: {
    imageExists () {
      return this.getUploadById ? true : false
    },

    ratio () {
      try{
        return this.aspectRatio || this.getUploadById.aspectRatio || '3'
      }catch(err){
        return "1"
      }
    },

    actualWidth () {
      if(this.$el){
        return this.$el.style.outerWidth
      }else{
        return "200"
      }
    },

    imgSrc() {
      try{
        return `${process.env.VUE_APP_CDN_URL}/${this.getUploadById.filename}`
      }catch(err){
        return "default"
      }
    },

    lazySrc () {
      return `${this.imgSrc}-320w.webp`
    },

    src () {
      return `${this.imgSrc}-160w.webp`
    },

    srcsetWebp () {
      return `
        ${this.imgSrc}-1920w.webp 1920w, 
        ${this.imgSrc}-1600w.webp 1600w, 
        ${this.imgSrc}-1366w.webp 1366w, 
        ${this.imgSrc}-1024w.webp 1024w, 
        ${this.imgSrc}-768w.webp 768w, 
        ${this.imgSrc}-640w.webp 640w,
        ${this.imgSrc}-320w.webp 320w,
        ${this.imgSrc}-160w.webp 160w,
      `
    },
    sizes () {
      switch (this.type) {
        case "tiny":
          return `
          10vw
          `
          break;
      
        case "small":
          return `
          (min-width: 600px) 400px, 100vw
          `
          break;
      
        default:
          return "100vw"
          break;
      }
    },
  }
}
</script>